<color-picker
  (changeColor)="onChangeColor($event)"
  (changematte)="onChangeMatte($event)"
></color-picker>
<tree-selector (changeSelectedMaterialNames)="changeSelectedMaterials($event)"></tree-selector>
